// extracted by mini-css-extract-plugin
module.exports = {"contacts__form-title":"style_contacts__form-title__Y4bIe","contacts__form-subtitle":"style_contacts__form-subtitle__SpLrH","contacts__form-tel":"style_contacts__form-tel__ZVIKN"};